import { GLOBAL_OBJ } from '@sentry/core';
const WINDOW = GLOBAL_OBJ;
export { WINDOW };